
import GHGeometryObject from './GHGeometryObject';
import Events from '../Events';

export default class GHValueListObject extends GHGeometryObject {
  constructor (ghObject) {
    super(ghObject);

    this.keys = [];
    this.values = [];
    this.__selected = 0;
  }

  get selected () {
    return this.__selected;
  }

  set selected (v) {
    this.__selected = v;
  }

  change (v) {
    this.selected = v;
    this.emit(Events.UI_CHANGE, this);
  }
}



// WEBPACK FOOTER //
// ./src/assets/javascripts/gh/GHValueListObject.js